module.exports = __webpack_public_path__ + "img/duanwu_ps_10.f216b40b.jpg";